<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
	import "./assets/table.scss"
	export default {
	  name: 'app'
	}
</script>

<style>
  	@import '~normalize.css/normalize.css';
  	@import '//at.alicdn.com/t/font_465165_s282ih376gczncdi.css';
  	@import './assets/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue